export default {"src":"/_next/static/media/searchIcon.3fec0bce.svg","height":25,"width":26,"blurWidth":0,"blurHeight":0};